import React, { } from "react";
import { View, Grid, useTheme, Card } from "@aws-amplify/ui-react";

import TitleSection from "../../components/titlesection/TitleSection";
import "./top5list.css";


const topqueries = [
    { id: 1, query: 'What is the default risk for Silicon Valley Bank?' },
    { id: 2, query: 'IWhat were the Q2 2024 earnings for Wells Fargo?' },
    { id: 3, query: 'Create an investment memo for investing in Bank Notes?' },
    { id: 4, query: 'Summarize 1940 securities act' },
    { id: 5, query: 'Company Policy.pdf' },
  ];

const topmodels = [
    { id: 1, query: 'BERT' },
    { id: 2, query: 'model x' },
    { id: 3, query: 'model z' },
    { id: 4, query: 'Model a' },
    { id: 5, query: 'Model b' },
  ];

const documentaccessed = [
    { id: 1, query: 'SVB_Earnings.pdf' },
    { id: 2, query: 'WFC_Earnings.pdf' },
    { id: 3, query: 'Investment memo.pdf' },
    { id: 4, query: '1940_IAA.pdf' },
    { id: 5, query: 'Company_policy.pdf' },
  ];

const Top5 = () => {
  const { tokens } = useTheme();


  return (
    <>
      <TitleSection title="Top 5" />
      <View borderRadius="5px" maxWidth="100%" padding="0rem" minHeight="100vh">
        <Grid
          templateColumns={{ base: "1fr", large: "1fr 1fr 1fr" }}
          templateRows={{ base: "repeat(4, auto)", large: "repeat(3, auto)" }}
          gap={tokens.space.xl}
        >

          <View columnSpan={[1, 1, 3]} rowSpan={{ base: 3, large: 4 }}>
            <Grid templateColumns={{ base: "1fr", large: "1fr 1fr" }} gap={tokens.space.xl}>
              <View rowSpan={{ base: 1, large: 1 }}>
              <Card className="topqueries">
              <h3 className="mb-4">Top 5 Queries</h3>
              <ul>
                {topqueries.map(item => (
                <li key={item.id}>
                     {item.query}
                </li>
                ))}
             </ul>
             </Card>
              </View>
              <View rowSpan={{ base: 1, large: 1 }}>
               <Card className="topmodels">
              <h3 className="mb-4">Top 5 Models / datasets</h3>
              <ul>
                {topmodels.map(item => (
                <li key={item.id}>
                     {item.query}
                </li>
                ))}
             </ul>
             </Card> 
              </View>
            </Grid>
          </View>
        </Grid>

        <Grid className="mt-30"
          templateColumns={{ base: "1fr", large: "1fr 1fr 1fr" }}
          templateRows={{ base: "repeat(4, auto)", large: "repeat(3, auto)" }}
          gap={tokens.space.xl}
        >
          <View columnSpan={[1, 1, 1]} rowSpan={{ base: 3, large: 4 }}>
           <Card className="documentaccessed">
           <h3 className="mb-4">Top 5 Documents Accessed</h3>
              <ul>
                {documentaccessed.map(item => (
                <li key={item.id}>
                     {item.query}
                </li>
                ))}
           </ul>
           </Card>  
          </View>
          <View columnSpan={[1, 1, 1]} rowSpan={{ base: 3, large: 4 }}>
          <Card className="topperformers">
          <h3 className="mb-4">Top Performers</h3>
          <table>
                <tr>
                  <td>
                    <div className="avatar">
                    <img alt="avatar" src={process.env.PUBLIC_URL + "/topperformers/1.png"}></img>
                    </div>
                  </td>
                  <td><span className="name">Boris Vasilyev</span></td>
                </tr>
                <tr>
                  <td>
                    <div className="avatar">
                      <img alt="avatar" src={process.env.PUBLIC_URL + "/topperformers/2.png"}></img>
                    </div>
                  </td>
                  <td>
                    <span className="name">
                    Julian Lo Dico
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="avatar">
                    <img alt="avatar" src={process.env.PUBLIC_URL + "/topperformers/3.png"}></img>
                    </div>
                  </td>
                  <td>
                    <span className="name">Magdalena Brela</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="avatar">
                    <img alt="avatar" src={process.env.PUBLIC_URL + "/topperformers/4.png"}></img>
                    </div>
                  </td>
                  <td><span className="name">Sanjeev Kumar</span></td>
                </tr>
                <tr>
                  <td>
                    <div className="avatar">
                    <img alt="avatar" src={process.env.PUBLIC_URL + "/topperformers/5.png"}></img>
                    </div>
                  </td>
                  <td><span className="name">Surajeet Bhuinya</span></td>
                </tr>
              </table>
          </Card>
          </View>
          <View columnSpan={[1, 1, 1]} rowSpan={{ base: 3, large: 4 }}>
          <Card className="topapi">
          <h3 className="mb-4">Top 5 APIs</h3>
          <table>
                <tr>
                  <td>
                    <div className="avatar">
                    <img alt="avatar" src={process.env.PUBLIC_URL + "/topapi/1.png"}></img>
                    </div>
                  </td>
                  <td><span className="name">Gmail</span></td>
                </tr>
                <tr>
                  <td>
                    <div className="avatar">
                      <img alt="avatar" src={process.env.PUBLIC_URL + "/topapi/2.png"}></img>
                    </div>
                  </td>
                  <td>
                    <span className="name">
                    Salesforce
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="avatar">
                    <img alt="avatar" src={process.env.PUBLIC_URL + "/topapi/3.png"}></img>
                    </div>
                  </td>
                  <td>
                    <span className="name">Trello</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="avatar">
                    <img alt="avatar" src={process.env.PUBLIC_URL + "/topapi/4.png"}></img>
                    </div>
                  </td>
                  <td><span className="name">Airtable</span></td>
                </tr>
                <tr>
                  <td>
                    <div className="avatar">
                    <img alt="avatar" src={process.env.PUBLIC_URL + "/topapi/5.png"}></img>
                    </div>
                  </td>
                  <td><span className="name">Influx DB</span></td>
                </tr>
              </table>
          </Card>
          </View>
        </Grid>
      </View>
    </>
  );
};

export default Top5;
